import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {useAccessibilityMode} from "./useAccessibilityMode";
import {Link} from "@mui/material";
import {Fragment, useEffect} from "react";

export default function AccessibilityButton() {

    useEffect(() => {
        window.special && window.special.Off();
        document.cookie = "special=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
    }, []);

    return (
        <Fragment>
            <Link
                aria-label="Переключить версию для слабовидящих"
                title="Версия для слабовидящих"
                tabIndex={0}
                onClick={window.special && window.special.On}
                className={`fixed bottom-4 right-4 px-4 py-2 text-sm font-medium focus:outline-none transition 
        focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
            >
                <RemoveRedEyeIcon sx={{ fontSize: 50 }}/>
            </Link>
        </Fragment>
    );
}
